import "./App.css";
import Exterior from "./components/Exterior";
import Interior from "./components/Interior";
import { useState } from "react";

export default function CarViewer() {
  const [widgetSelected, setWidgetSelected] = useState("exterior");

  return (
    <>
      {/* <div className="header">AITO M5 Configurator Demo</div> */}

      <div className="configurator">
        <div className="configurator-navigation">
          <button
            className={`configurator-navigation__button ${
              widgetSelected === "exterior" &&
              "configurator-navigation__button--active"
            }`}
            onClick={() => setWidgetSelected("exterior")}
          >
            Экстерьер
          </button>

          <button
            className={`configurator-navigation__button ${
              widgetSelected === "interior" &&
              "configurator-navigation__button--active"
            }`}
            onClick={() => setWidgetSelected("interior")}
          >
            Интерьер
          </button>
        </div>

        {widgetSelected === "interior" ? <Interior /> : <Exterior />}
      </div>
    </>
  );
}
